import {
  SET_POST_OFFICES
} from 'src/store/mutation-types'
export default {
  [SET_POST_OFFICES] (state, postOffice) {
    state.postOffice = postOffice
  }
}



// WEBPACK FOOTER //
// ./src/components/postOffice/store/mutations.js